import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWhatsappComponent } from './simple-icons-whatsapp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWhatsappComponent ],
    exports:      [ SimpleIconsWhatsappComponent ],
    bootstrap:    []
})
export class SimpleIconsWhatsappModule {}
